export const partnerPaymentSettings = {
    title: 'Welcome to Blink {{partnerName}}',
    paymentMethodSelector: {
        title: 'Payment method details',
        noPaymentMethod: 'No payment method',
        addMethod: 'Add a payment method'
    },
    paymentMethodModal: {
        title: 'Choosing the payment method',
        description: 'The payment for the system additions can be made by credit card or by offset from the planned transfer to the account',
        creditCard: 'Credit Card',
        fromTransfer: 'Offset from transfer',
    },
    systemFeatures: {
        title: 'System add-ons',
        completeSystem:  {
            label: 'Complete system',
            description: 'NIS 25 per building for a complete system with no limitation of features',
        },
        greenInvoice:  {
            label: 'Green invoice',
            description: 'Monthly payment according to engagement agreement, without limitation of buildings or documents',
        },
        maintenance:  {
            label: 'Maintenance',
            description: 'Monthly payment according to engagement agreement',
        },
        checkScanner:  {
            label: 'Check scanner',
            description: 'Monthly payment according to engagement agreement',
        },
        active: 'active',
        disabled: 'off',
        actions: {
            add: 'addition'
        }
    },
    notifications: {
        paymentMethodEstablished: 'New payment method established'
    }
};
